module.exports = __webpack_public_path__ + "static/media/Firebase.6caacd1a.svg";